<template>
  <v-card flat height="100%">
    <v-card-title>
      <v-layout>
        <v-flex xs8 ma-2>Bestelldokumente für {{praxisname}} hochladen</v-flex>
      </v-layout>
    </v-card-title>
    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-alert
          text
          color="info"
          v-if="praxisgemeinschaft"
        >Bitte beachten Sie, dass bei Praxisgemeinschaften jeweils ein Vertrag pro Praxis (HBSNR) vorliegen muss!</v-alert>
        <v-alert text color="error" v-if="message !== undefined && message !== null">
          <h3 class="headline">Beanstandungen</h3>
          {{message}}
        </v-alert>
        <v-menu
          v-model="installDateMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
          v-if="!lizenzaenderung"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="installDate"
              readonly
              label="Startdatum Softwarepflege"
              v-on="on"
              :rules="installDateRule"
              clearable
            ></v-text-field>
          </template>
          <v-date-picker v-model="installDate" @input="installDateMenu = false"></v-date-picker>
        </v-menu>
        <v-file-input
          :rules="inputRules"
          accept="application/pdf"
          placeholder="Bestelldokumente auswählen"
          v-model="file"
          multiple
          counter
          small-chips
          show-size
          clearable
          hint="in dem Dateiauswahl-Dialog können durch Shift und Strg (Cmd) Tastendruck mehrere Dateien ausgewählt und hochgeladen werden."
          persistent-hint
        ></v-file-input>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="error"
        @click="deleteDialog = true"
        v-if="!lizenzaenderung"
      >Bestellung stornieren</v-btn>
      <v-btn
        color="primary"
        @click="upload"
        :disabled="disableUploadButton"
      >Unterschriebene Bestelldokumente hochladen</v-btn>
    </v-card-actions>
    <v-dialog v-model="deleteDialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Bestellung wirklich stornieren?</v-card-title>
        <v-card-text>Das Stornieren der Bestellung kann nicht rückgängig gemacht werden.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="deleteDialog = false">Nein</v-btn>
          <v-btn color="blue darken-1" text @click="stopOrder">Ja</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import { mapState } from "vuex";
const convertFiletoBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
async function convertFilesToBase64(files) {
  const newFiles = [];
  for (let index = 0; index < files.length; index++) {
    const file = {
      filename: files[index].name,
      file: await convertFiletoBase64(files[index])
    };
    newFiles.push(file);
  }
  return newFiles;
}

export default {
  data() {
    return {
      valid: false,
      deleteDialog: false,
      file: [],
      installDateMenu: false,
      installDate: null,
      installDateRule: [
        v =>
          !v ||
          (v !== null && v !== "") ||
          "Das Installationsdatum darf nicht leer sein"
      ],
      inputRules: [
        v =>
          !v ||
          v.map(file => file.size).every(size => size < 7000000) ||
          "Die einzelnen Bestelldokumente dürfen nicht größer als 7 MB sein",
        v =>
          !v ||
          v
            .map(file => file.size)
            .reduce(
              (accumulator, currentValue) => accumulator + currentValue,
              0
            ) < 50000000 ||
          "Die Bestelldokumente dürfen zusammen nicht größer als 50 MB sein!"
      ]
    };
  },
  computed: {
    ...mapState({
      message: state => state.uploadedDocumentResult.message,
      praxisgemeinschaft: state =>
        state.current.bestellung.praxisart === "PRAXISGEMEINSCHAFT",
      lizenzaenderung: state => state.current.bestellung.lizenz.lizenzaenderung,
      praxisname: state => state.current.bestellung.praxisName
    }),
    disableUploadButton: function() {
      if (this.lizenzaenderung) {
        return (
          this.file === [] ||
          this.$refs.form === undefined ||
          (this.$refs.form !== undefined && !this.$refs.form.validate())
        );
      } else {
        return (
          this.file === [] ||
          this.installDate === null ||
          this.$refs.form === undefined ||
          (this.$refs.form !== undefined && !this.$refs.form.validate())
        );
      }
    }
  },
  mounted: function() {
    this.$store.commit("startLoading");
    this.$socket.sendObj({
      eventID:
        "de.t2med.lizenzomat.eventapi.usecase.order.bestelldokumente.BestelldokumenteUploadOverviewRequestEvent",
      taskId: this.$route.params.task,
      processId: this.$route.params.process
    });
  },
  methods: {
    home: function() {
      this.$router.push("/");
    },
    stopOrder: function() {
      this.$store.commit("startLoading");
      this.$socket.sendObj({
        eventID:
          "de.t2med.lizenzomat.eventapi.usecase.order.bestelldokumente.BestellungStornierenRequestEvent",
        taskId: this.$route.params.task,
        processId: this.$route.params.process
      });
    },
    upload: function() {
      if (this.$refs.form.validate()) {
        convertFilesToBase64(this.file).then(files => {
          this.$store.commit("startLoading");
          this.$socket.sendObj({
            eventID:
              "de.t2med.lizenzomat.eventapi.usecase.order.bestelldokumente.BestelldokumenteUploadRequestEvent",
            taskId: this.$route.params.task,
            processId: this.$route.params.process,
            installDate: this.installDate,
            files: files
          });
        });
      }
    }
  }
};
</script>
